<template>
  <l-layout :layout="['xs12']">
    <v-card class="pa-3">
      <v-form ref="templateForm">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="模板名称" prepend-icon="$vuetify.icons.title"
                            v-model="form.name" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="所属业务系统名" prepend-icon="$vuetify.icons.location" v-model="form.institutionId" :urles="[$rules.requiredS()]"
                            :disabled="disabledFlag"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-select :items="form.typeSelect" v-model="form.type" label="发送渠道" prepend-icon="$vuetify.icons.letter"
                        item-text="label" item-value="value"
                        :disabled="disabledFlag" :rules="[$rules.requiredS()]">
              </v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="发送ID" prepend-icon="$vuetify.icons.code" v-model="form.sendId" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></v-text-field>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-textarea rows="1" auto-grow label="模板描述" prepend-icon="$vuetify.icons.comment" v-model="form.description" :disabled="disabledFlag"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-textarea rows="1" auto-grow label="模板内容" prepend-icon="$vuetify.icons.comment" v-model="form.content" :disabled="disabledFlag"></v-textarea>
          </v-flex>
          <v-layout>
            <v-flex xs6>
              <l-autocomplete
                :disabled="disabledFlag"
                label="关联系统标签"
                :get-data="findSysLabel"
                item-text="name"
                prepend-icon="$vuetify.icons.code"
                v-model="form.sysLabelList"
                chips
                multiple
              ></l-autocomplete>
            </v-flex>
            <v-flex xs6>
              <l-autocomplete
                :disabled="disabledFlag"
                label="关联自定义标签"
                :get-data="findBizLabel"
                item-text="name"
                prepend-icon="$vuetify.icons.code"
                v-model="form.bizLabelList"
                chips
                multiple
              ></l-autocomplete>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-form>
      <v-layout justify-center v-if="!disabledFlag">
        <v-btn class="primary" :loading="loading" :disabled="disabledFlag" @click="submit">提交</v-btn>
      </v-layout>
      <v-layout justify-center v-else>
        <v-btn class="primary" @click="disabledFlag=!disabledFlag">修改</v-btn>
      </v-layout>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'templateDetail',
  props: {
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      disabledFlag: true,
      form: {
        name: '',
        description: '',
        content: '',
        sysLabelList: [],
        bizLabelList: [],
        institutionId: '',
        typeSelect: [
          {value: 'mail', label: '邮件发送'},
          {value: 'sms', label: '短信发送'},
          {value: 'wechat', label: '微信发送'},
          {value: 'letter', label: '站内私信'}
        ],
        sendId: '',
        type: ''
      }
    }
  },
  created () {
    console.log(this.formData)
    this.init()
  },
  methods: {
    init () {
      this.form.name = this.formData.name
      this.form.description = this.formData.description
      this.form.content = this.formData.tmpltContent
      this.form.institutionId = this.formData.institutionId
      this.form.type = this.formData.type
      this.form.sendId = this.formData.sendId
      for (let i = 0; i < this.formData.tmpltSyss.length; i++) {
        this.form.sysLabelList.push(this.formData.tmpltSyss[i].msgLabelSys)
      }
      for (let i = 0; i < this.formData.tmpltBizs.length; i++) {
        this.form.bizLabelList.push(this.formData.tmpltBizs[i].msgLabelBiz)
      }
    },
    async findSysLabel (searchValue) {
      try {
        let url = '/messageApi/admin/getMsgLabelSys'
        let {items, amount} = await this.$store.dispatch('message/getList', {pagination: {pages: 1, rowsPerPage: 10}, search: {key: 'name', value: searchValue}, url: url})
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async findBizLabel (searchValue) {
      try {
        let url = '/messageApi/admin/getMsgLabelBiz'
        let {items, amount} = await this.$store.dispatch('message/getList', {pagination: {pages: 1, rowsPerPage: 10}, search: {key: 'name', value: searchValue}, url: url})
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async submit () {
      if (this.$refs.templateForm.validate()) {
        let sysList = []
        let bizList = []
        for (let i = 0; i < this.form.sysLabelList.length; i++) {
          sysList.push(this.form.sysLabelList[i].id)
        }
        for (let i = 0; i < this.form.bizLabelList.length; i++) {
          bizList.push(this.form.bizLabelList[i].id)
        }
        let params = {'msgTmplt': {'name': this.form.name,
          'id': this.formData.id,
          'description': this.form.description,
          'institutionId': this.form.institutionId,
          'sendId': this.form.sendId,
          'type': this.form.type,
          'tmpltContent':
              this.form.content},
        'sysList': sysList,
        'bizList': bizList}
        let url = '/messageApi/admin/addMsgTmplt'
        this.loading = true
        try {
          let res = await this.$store.dispatch('message/addActions', {params: params, url: url})
          if (res.data.code + '' === '200') {
            this.$L.alert('success', {message: '更新成功'})
            this.disabledFlag = true
            this.$store.commit('message/setTemplateRefresh', true)
          }
          else {
            this.$L.alert('error', {message: '更新失败，原因:' + res.data.msg})
          }
        }
        catch (e) {
          console.log(e)
        }
        finally {
          this.loading = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    }
  }
}
</script>

<style scoped>

</style>
